/**
 * OHIF's 3D layouts — "3D four up", "3D main", "3D only", "3D primary" (in French "3D quatre vues", "Vue
 * principale 3D", "3D seulement", "3D principale") — left out of the layout selector: labelling works on the
 * 2D views and MPR. The cornerstone extension registers them as presets; the selector's advanced presets are
 * the protocols marked `isPreset` (layoutSelector.advancedPresetGenerator), so unmarking them hides them
 * without touching the upstream files.
 */
export const HIDDEN_LAYOUT_PROTOCOLS = ['fourUp', 'main3D', 'only3D', 'primary3D'];

type ProtocolHolder = { protocols: Map<string, { isPreset?: boolean }> };

export function hideLayouts(
  hangingProtocolService: ProtocolHolder,
  protocolIds: string[] = HIDDEN_LAYOUT_PROTOCOLS
) {
  protocolIds.forEach(protocolId => {
    const protocol = hangingProtocolService.protocols.get(protocolId);
    if (protocol) {
      protocol.isPreset = false;
    }
  });
}
